export default __webpack_public_path__ + "static/media/meals.71655c4e.jpg";